export default "__VITE_ASSET__BJd5fW5t__"